import { render } from "./Widget13.vue?vue&type=template&id=0fd74346"
import script from "./Widget13.vue?vue&type=script&lang=js"
export * from "./Widget13.vue?vue&type=script&lang=js"
script.render = render

export default script